import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import "../static/pet-portal.css";

const taskLabels = {
  1: "Wash & Go",
  2: "Full Grooming",
  3: "Nail Care",
  4: "Teeth",
  5: "Other",
};

const getOwnerId = (owner) => {
  if (owner && typeof owner === "object") return owner.id || "";
  return owner || "";
};

const formatDateKey = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const formatDisplayDate = (value) => {
  if (!value) return "—";

  const parsed = new Date(`${String(value).slice(0, 10)}T12:00:00`);

  if (Number.isNaN(parsed.getTime())) return value;

  return parsed.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const toYesNo = (value) => {
  return value === true ||
    String(value).toLowerCase() === "true" ||
    String(value).toLowerCase() === "yes"
    ? "Yes"
    : "No";
};

const HistoryGromming = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const params = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const [pet] = useState(() => {
    const statePet = location.state?.pet || {};

    return {
      id: statePet.id ?? params.get("id") ?? "",
      name: statePet.name ?? params.get("name") ?? "Pet profile",
      catdog: statePet.catdog ?? params.get("catdog") ?? "Pet",
      breed: statePet.breed ?? params.get("breed") ?? "Not added",
      gender: statePet.gender ?? params.get("gender") ?? "Not added",
      age: statePet.age ?? params.get("age") ?? "Not added",
      image: statePet.image ?? params.get("image") ?? "",
      phone: statePet.phone ?? params.get("phone") ?? "",
      behaviour: statePet.behaviour ?? params.get("behaviour") ?? "Not added",
      vaccinated: statePet.vaccinated ?? params.get("vaccinated") ?? false,
      neutered: statePet.neutered ?? params.get("neutered") ?? false,
      grooming_history:
        statePet.grooming_history ?? params.get("grooming_history") ?? "—",
      social_media_consent:
        statePet.social_media_consent ??
        params.get("social_media_consent") ??
        "—",
      owner: statePet.owner ?? params.get("owner") ?? "",
      owner_name: statePet.owner_name ?? params.get("owner_name") ?? "",
    };
  });

  const ownerId = getOwnerId(pet.owner);
  const initialBookingDate =
    location.state?.date || params.get("date") || "";

  const initialBookingHour =
    location.state?.hour || params.get("hour") || "";

  const [ownerData, setOwnerData] = useState(null);
  const [messages, setMessages] = useState([]);
  const [groomingHistory, setGroomingHistory] = useState([]);
  const [staffList, setStaffList] = useState([]);

  const [messageForm, setMessageForm] = useState({
    subject: "",
    text: "",
    sender: "groomer",
  });

const [bookingForm, setBookingForm] = useState({
  commenthim: "",
  commentus: "",
  task: "",
  datee: initialBookingDate || formatDateKey(new Date()),
  hour: initialBookingHour || "",
  staff: "1",
});

  const [notice, setNotice] = useState({
    type: "",
    text: "",
  });


  const halfHourOptions = Array.from({ length: 25 }, (_, index) => {
  const totalMinutes = 8 * 60 + index * 30;
  const hour = Math.floor(totalMinutes / 60);
  const minute = totalMinutes % 60;

  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(
    2,
    "0"
  )}`;
});


  const ownerName =
    ownerData?.name || pet.owner_name || "Owner details pending";

  const ownerPhone =
    ownerData?.phone_mobile || ownerData?.phone || pet.phone || "—";

  useEffect(() => {
    if (!ownerId) return;

    axios
      .get(`/getowner?owner=${encodeURIComponent(ownerId)}`)
      .then((response) => {
        const result = Array.isArray(response.data)
          ? response.data[0]
          : response.data;

        setOwnerData(result || null);
      })
      .catch((error) => {
        console.error("Could not load owner:", error);
      });
  }, [ownerId]);

  useEffect(() => {
    if (!ownerId || !pet.id) return;

    axios
      .get(
        `/message-pet?owner=${encodeURIComponent(
          ownerId
        )}&pet=${encodeURIComponent(pet.id)}`
      )
      .then((response) => {
        const result = Array.isArray(response.data)
          ? response.data
          : response.data?.data || [];

        setMessages(result);
      })
      .catch((error) => {
        console.error("Could not load messages:", error);
      });
  }, [ownerId, pet.id]);

  useEffect(() => {
    if (!ownerId || !pet.id) return;

    axios
      .get(
        `/grooming-pet?owner=${encodeURIComponent(
          ownerId
        )}&pet=${encodeURIComponent(pet.id)}`
      )
      .then((response) => {
        const result = Array.isArray(response.data)
          ? response.data
          : response.data?.data || [];

        setGroomingHistory(result);
      })
      .catch((error) => {
        console.error("Could not load grooming history:", error);
      });
  }, [ownerId, pet.id]);

  useEffect(() => {
    axios
      .get("/staff/")
      .then((response) => {
        setStaffList(Array.isArray(response.data) ? response.data : []);
      })
      .catch((error) => {
        console.error("Could not load staff:", error);
      });
  }, []);

  const sortedMessages = useMemo(() => {
    return [...messages].sort((a, b) => {
      const aDate = `${a.datee || ""}T${a.time || "00:00"}`;
      const bDate = `${b.datee || ""}T${b.time || "00:00"}`;

      return bDate.localeCompare(aDate);
    });
  }, [messages]);

  const sortedGroomingHistory = useMemo(() => {
    return [...groomingHistory].sort((a, b) => {
      const aDate = `${a.datee || ""}T${a.hour || "00:00"}`;
      const bDate = `${b.datee || ""}T${b.hour || "00:00"}`;

      return bDate.localeCompare(aDate);
    });
  }, [groomingHistory]);

  const lastGrooming = sortedGroomingHistory[0] || null;

  const handleMessageSubmit = async (event) => {
    event.preventDefault();

    if (!messageForm.text.trim()) {
      setNotice({
        type: "error",
        text: "Please write a message first.",
      });
      return;
    }

    const now = new Date();

    const payload = {
      subject: messageForm.subject.trim() || "No subject",
      text: messageForm.text.trim(),
      sender: messageForm.sender || "Arys Grooming",
      pet: pet.id,
      owner: ownerId,
      datee: formatDateKey(now),
      time: now.toTimeString().slice(0, 5),
    };

    try {
      const response = await axios.post("/create-message/", payload);

      const savedMessage =
        response.data?.id
          ? response.data
          : { ...payload, id: `local-message-${Date.now()}` };

      setMessages((current) => [savedMessage, ...current]);

      setMessageForm({
        subject: "",
        text: "",
        sender: "groomer",
      });

      setNotice({
        type: "success",
        text: "Message saved successfully.",
      });
    } catch (error) {
      console.error(error);

      setNotice({
        type: "error",
        text: "Message could not be saved. Please try again.",
      });
    }
  };

  const handleBookingSubmit = async (event) => {
    event.preventDefault();

    if (!bookingForm.task || !bookingForm.datee || !bookingForm.hour) {
      setNotice({
        type: "error",
        text: "Please choose a service, date and hour.",
      });
      return;
    }

    const bookingDate = new Date(`${bookingForm.datee}T12:00:00`);

    const payload = {
      petname: pet.name || "",
      pet: pet.id,
      owner: ownerId,
      ownername: ownerName,
      commenthim: bookingForm.commenthim || "",
      commentus: bookingForm.commentus || "",
      task: bookingForm.task,
      status: "2",
      datee: bookingForm.datee,
      staff: bookingForm.staff || 1,
      week: bookingDate.toLocaleDateString("en-US", {
        weekday: "long",
      }),
      hour: bookingForm.hour,
      done: 0,
      waitingtime: "3",
      behaviour: pet.behaviour || "",
      catordog: pet.catdog || "",
    };

    try {
      const response = await axios.post("/create_grooming/", payload);

      const savedBooking =
        response.data?.datee
          ? response.data
          : { ...payload, id: `local-booking-${Date.now()}` };

      setGroomingHistory((current) => [savedBooking, ...current]);

      setBookingForm({
        commenthim: "",
        commentus: "",
        task: "",
        datee: "",
        hour: "",
        staff: "1",
      });

      setNotice({
        type: "success",
        text: "Next grooming appointment saved successfully.",
      });
    } catch (error) {
      console.error(error);

      setNotice({
        type: "error",
        text: "Appointment could not be saved. Please check the fields.",
      });
    }
  };

  const profileItems = [
    ["Pet type", pet.catdog],
    ["Breed", pet.breed],
    ["Gender", pet.gender],
    ["Age", pet.age],
    ["Behaviour", pet.behaviour],
    ["Vaccinated", toYesNo(pet.vaccinated)],
    ["Neutered", toYesNo(pet.neutered)],
    ["Social media consent", pet.social_media_consent || "—"],
  ];

  return (
    <main className="petportal">
      <header className="petportal-topbar">
        <button
          type="button"
          className="petportal-back"
          onClick={() => navigate(-1)}
        >
          ← Back
        </button>

        <span className="petportal-brand">Arys Grooming</span>
      </header>

      <section className="petportal-hero">
        <div className="petportal-hero-main">
          <div className="petportal-avatar">
            {pet.image ? (
              <img
                src={pet.image}
                alt={pet.name}
                onError={(event) => {
                  event.currentTarget.style.display = "none";
                }}
              />
            ) : (
              <span>{String(pet.name || "P").charAt(0).toUpperCase()}</span>
            )}
          </div>

          <div>
            <span className="petportal-eyebrow">
              {pet.catdog || "Pet"} profile
            </span>

            <h1>{pet.name}</h1>

            <p className="petportal-subtitle">
              A simple place for profile details, messages and bookings.
            </p>

            <div className="petportal-owner-line">
              <span>Owner</span>
              <strong>{ownerName}</strong>
              <small>{ownerPhone}</small>
            </div>
          </div>
        </div>

        <div className="petportal-hero-actions">
          <a href="#message">Write message</a>
          <a href="#booking">Book appointment</a>
        </div>
      </section>

      <nav className="petportal-nav">
        <a href="#overview">Overview</a>
        <a href="#messages">Messages</a>
        <a href="#booking">New booking</a>
        <a href="#history">History</a>
      </nav>

      {notice.text && (
        <div className={`petportal-notice ${notice.type}`}>
          {notice.text}
        </div>
      )}

      <section className="petportal-layout" id="overview">
        <article className="petportal-card petportal-profile-card">
          <div className="petportal-card-head">
            <div>
              <span className="petportal-section-label">Profile</span>
              <h2>About {pet.name}</h2>
            </div>
          </div>

          <div className="petportal-profile-grid">
            {profileItems.map(([label, value]) => (
              <div className="petportal-info-row" key={label}>
                <span>{label}</span>
                <strong>{value || "—"}</strong>
              </div>
            ))}
          </div>
        </article>

        <aside className="petportal-card petportal-last-card">
          <span className="petportal-section-label">Latest visit</span>
          <h2>Last grooming</h2>

          {lastGrooming ? (
            <>
              <strong className="petportal-big-date">
                {formatDisplayDate(lastGrooming.datee)}
              </strong>

              <p>
                {lastGrooming.hour || "Time pending"} ·{" "}
                {taskLabels[lastGrooming.task] || "Grooming"}
              </p>

              <div className="petportal-mini-note">
                {lastGrooming.commentus ||
                  lastGrooming.commenthim ||
                  "No notes from the last visit."}
              </div>
            </>
          ) : (
            <p className="petportal-muted">No grooming records yet.</p>
          )}
        </aside>
      </section>

      <section className="petportal-card" id="messages">
        <div className="petportal-card-head">
          <div>
            <span className="petportal-section-label">Conversation</span>
            <h2>Messages</h2>
          </div>

          <span className="petportal-count">{messages.length}</span>
        </div>

        <div className="petportal-message-list">
          {sortedMessages.length > 0 ? (
            sortedMessages.map((message, index) => (
              <article
                className={`petportal-message ${
                  message.sender === "owner" ? "from-owner" : "from-groomer"
                }`}
                key={message.id || index}
              >
                <div className="petportal-message-meta">
                  <strong>
                    {message.sender === "owner" ? ownerName : "Arys Grooming"}
                  </strong>

                  <span>
                    {formatDisplayDate(message.datee)} ·{" "}
                    {String(message.time || "").slice(0, 5)}
                  </span>
                </div>

                <h3>{message.subject || "Message"}</h3>
                <p>{message.text || "—"}</p>
              </article>
            ))
          ) : (
            <div className="petportal-empty">No messages yet.</div>
          )}
        </div>
      </section>

      <section className="petportal-card" id="message">
        <div className="petportal-card-head">
          <div>
            <span className="petportal-section-label">New message</span>
            <h2>Write a message</h2>
          </div>
        </div>

        <form className="petportal-form" onSubmit={handleMessageSubmit}>
          <div className="petportal-form-grid">
            <label className="petportal-field">
              <span>Subject</span>
              <input
                 type="hidden"
                value={messageForm.subject}
                onChange={(event) =>
                  setMessageForm((current) => ({
                    ...current,
                    subject: event.target.value,
                  }))
                }
                placeholder="Short message title"
              />
            </label>

            <label className="petportal-field">
              <span>Sender</span>
              <select
                value={messageForm.sender}
                onChange={(event) =>
                  setMessageForm((current) => ({
                    ...current,
                    sender: event.target.value,
                  }))
                }
              >
                <option value="groomer">Arys Grooming</option>
                <option value="owner">Owner</option>
              </select>
            </label>
          </div>

          <label className="petportal-field">
            <span>Message</span>
            <textarea
              rows="5"
              value={messageForm.text}
              onChange={(event) =>
                setMessageForm((current) => ({
                  ...current,
                  text: event.target.value,
                }))
              }
              placeholder="Write a clear, friendly message..."
              required
            />
          </label>

          <button className="petportal-primary-button" type="submit">
            Send message
          </button>
        </form>
      </section>

      <section className="petportal-card" id="booking">
        <div className="petportal-card-head">
          <div>
            <span className="petportal-section-label">New booking</span>
            <h2>Book next grooming session</h2>
          </div>
        </div>

        <form className="petportal-form" onSubmit={handleBookingSubmit}>
          <div className="petportal-form-grid">
            <label className="petportal-field">
              <span>Service</span>
              <select
                value={bookingForm.task}
                onChange={(event) =>
                  setBookingForm((current) => ({
                    ...current,
                    task: event.target.value,
                  }))
                }
                required
              >
                <option value="">Choose service</option>
                <option value="1">Wash & Go</option>
                <option value="2">Full Grooming</option>
                <option value="3">Nail Care</option>
                <option value="4">Teeth</option>
                <option value="5">Other</option>
              </select>
            </label>

            <label className="petportal-field">
              <span>Groomer</span>
              <select
                value={bookingForm.staff}
                onChange={(event) =>
                  setBookingForm((current) => ({
                    ...current,
                    staff: event.target.value,
                  }))
                }
              >
                 
                {staffList.map((staff) => (
                  <option key={staff.id} value={staff.id}>
                    {staff.name}
                  </option>
                ))}
              </select>
            </label>

            <label className="petportal-field">
              <span className="petportal-date-label">
                Date

                <button
                  type="button"
                  className="petportal-today-button"
                  onClick={() =>
                    setBookingForm((current) => ({
                      ...current,
                      datee: formatDateKey(new Date()),
                    }))
                  }
                >
                  Today
                </button>
              </span>

              <input
                type="date"
                value={bookingForm.datee}
                min={formatDateKey(new Date())}
                onChange={(event) =>
                  setBookingForm((current) => ({
                    ...current,
                    datee: event.target.value,
                  }))
                }
                required
              />
            </label>

            <label className="petportal-field">
              <span>Time</span>

              <select
                value={bookingForm.hour}
                onChange={(event) =>
                  setBookingForm((current) => ({
                    ...current,
                    hour: event.target.value,
                  }))
                }
                required
              >
                <option value="">Choose time</option>

                {halfHourOptions.map((time) => (
                  <option key={time} value={time}>
                    {time}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <div className="petportal-form-grid">
            <label className="petportal-field">
              <span>Owner note</span>
              <textarea
                rows="4"
                value={bookingForm.commenthim}
                onChange={(event) =>
                  setBookingForm((current) => ({
                    ...current,
                    commenthim: event.target.value.slice(0, 300),
                  }))
                }
                placeholder="Anything the owner would like us to know?"
              />
              <small>{bookingForm.commenthim.length}/300</small>
            </label>

            <label className="petportal-field">
              <span>Groomer note</span>
              <textarea
                rows="4"
                value={bookingForm.commentus}
                onChange={(event) =>
                  setBookingForm((current) => ({
                    ...current,
                    commentus: event.target.value.slice(0, 300),
                  }))
                }
                placeholder="Internal preparation note"
              />
              <small>{bookingForm.commentus.length}/300</small>
            </label>
          </div>

          <button className="petportal-primary-button" type="submit">
            Save appointment
          </button>
        </form>
      </section>

      <section className="petportal-card" id="history">
        <div className="petportal-card-head">
          <div>
            <span className="petportal-section-label">Appointments</span>
            <h2>Grooming history</h2>
          </div>

          <span className="petportal-count">{groomingHistory.length}</span>
        </div>

        <div className="petportal-history-list">
          {sortedGroomingHistory.length > 0 ? (
            sortedGroomingHistory.map((record, index) => (
              <article
                className="petportal-history-row"
                key={record.id || index}
              >
                <div>
                  <strong>{formatDisplayDate(record.datee)}</strong>
                  <span>{record.week || "—"}</span>
                </div>

                <div>
                  <strong>{record.hour || "—"}</strong>
                  <span>{taskLabels[record.task] || "Grooming"}</span>
                </div>

                <p>
                  {record.commentus ||
                    record.commenthim ||
                    "No appointment notes."}
                </p>
              </article>
            ))
          ) : (
            <div className="petportal-empty">No appointments yet.</div>
          )}
        </div>
      </section>

      <footer className="petportal-footer">
        Arys Grooming · Pet care made simple
      </footer>
    </main>
  );
};

export default HistoryGromming;
